// Stateless action-bundle bridge. Socket retention and admission stay in websocket.
import { saveAppliedTruth } from './applied-truth-transport';
import type { AppliedFrameResult } from '../janus-engine/transport/applied-frame';
export type DiceTruthCommand = Record<string, unknown> & { operation_id: string };
declare global { interface Window {
    ftPushSavedDiceTruth?: (command: DiceTruthCommand, applied?: AppliedFrameResult) => void | Promise<void>;
} }
/** One immutable save command, bounded even when headers/body ignore AbortSignal. */
export async function saveDiceTruth(endpoint: string, command: DiceTruthCommand): Promise<{ status: number; result: Record<string, unknown> }> {
    for (let attempt = 0; ; attempt++) {
        const response = await saveAppliedTruth(endpoint, command, { method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(command) });
        let timer: ReturnType<typeof setTimeout> | undefined;
        try {
            const result = await Promise.race([response.json(), new Promise<never>((_, reject) => {
                timer = setTimeout(() => reject(new Error('dice-save-answer-timeout')), 6000);
            })]) as Record<string, unknown>;
            return { status: response.status, result };
        } catch (error) {
            // A saved answer can be lost after headers too. Replay its existing
            // operation so the browser can recover the canonical row identities.
            if (attempt >= 2) throw error;
        } finally { clearTimeout(timer); }
    }
}
export function publishSavedDice(command: DiceTruthCommand, result: Record<string, unknown>, applied?: AppliedFrameResult): void {
    const identity = Object.fromEntries(['schema', 'operation_id', 'kind', 'encounter_id', 'campaign_id', 'item_id']
        .filter(key => key in command).map(key => [key, command[key]]));
    void window.ftPushSavedDiceTruth?.({ ...identity, operation_id: command.operation_id, actor_id: command.actor_id ?? command.caster_id ?? '',
        roll_rows: result.roll_rows ?? [], roll_updates: result.roll_updates ?? [],
        ...(command.schema === 'janus.charge.truth.v1' ? { current: result.current ?? command.after, rev: result.rev, committed: true } : {}) }, applied);
}
